export const popStateEventKey = ':popState';
export const pushStateEventKey = ':pushState';
export const linkScopeKey = 'data-scope';
